import React from "react";

const UseCases = () => {
	return <div className="mt-5">Use cases page</div>;
};

export default UseCases;
